import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// 配置 tailwind-merge 以支持 UnoCSS 的自定义类
// 将 text-body-* 和 text-h* 移到单独的分组，这样它们不会与 text-* 颜色类冲突
const customTwMerge = extendTailwindMerge({
  override: {
    classGroups: {
      'font-size': [
        { text: ['body-sm', 'body-md', 'body-lg', 'body-sm-bold', 'body-md-bold', 'body-lg-bold', 'h1', 'h2', 'h3', 'h4', 'h5'] }
      ]
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}